import { ValueAndLabel } from "./valueAndLabel.model";

export enum UserStatus {
    Created = 1,
    Active,
    Deleted,
    Banned
}

export const USER_STATUS: ValueAndLabel[] = [
    { id: UserStatus.Created, text: "登録" },
    { id: UserStatus.Active, text: "会員" },
    { id: UserStatus.Deleted, text: "退会" },
    { id: UserStatus.Banned, text: "強制退会" }
];

export enum UserPhotoStatus {
    UnderReview = 1,
    Rejected,
    Public
}
